import { language } from "shared/language";

export const VERSION_EXISTED = language.version_existed;
export const VERSION_NOT_FOUND = language.version_not_found;
export const CAN_NOT_REMOVE_VERSION = language.can_not_remove_version;
